import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "react-query";
import { RecoilRoot } from "recoil";
import { Auth0Provider } from "@auth0/auth0-react";
import { TelegramProvider } from "./common/Telegram/useTelegram";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const queryClient = new QueryClient();

const AUTH_0_CLIENT_ID = "2TQ9hVB5ERCHMIFtIsyZMHmGbsHCDP4o";
const AUTH_0_DOMAIN = "dev-5kgo8ucngdphuzot.us.auth0.com";

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={AUTH_0_DOMAIN}
      clientId={AUTH_0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
    >
      <QueryClientProvider client={queryClient}>
        <Router>
          <TelegramProvider>
            <RecoilRoot>
              <App />
            </RecoilRoot>
          </TelegramProvider>
        </Router>
        <ToastContainer
          autoClose={3000}
          draggable={false}
          hideProgressBar
          newestOnTop
          progressClassName="toastProgress"
        />
      </QueryClientProvider>
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
